import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.00016 7.75156C6.12616 7.75156 6.25156 7.79116 6.35836 7.86976L7.82296 8.95876L7.25296 7.18576C7.17376 6.94036 7.26076 6.67216 7.46836 6.51916L8.96776 5.41456L7.12876 5.41876H7.12756C6.86596 5.41876 6.63496 5.24956 6.55576 4.99996L6.00016 3.24676L5.44456 4.99996C5.36536 5.25016 5.13376 5.41396 4.87156 5.41876L3.03256 5.41456L4.53196 6.51916C4.73956 6.67216 4.82656 6.94036 4.74736 7.18576L4.17736 8.95876L5.64196 7.86976C5.74876 7.79116 5.87416 7.75156 6.00016 7.75156ZM8.96656 11.156C8.84056 11.156 8.71456 11.1164 8.60896 11.0378L6.00016 9.09916L3.39136 11.0378C3.18256 11.1926 2.89516 11.1962 2.68456 11.0438C2.47216 10.892 2.38276 10.6208 2.46256 10.3724L3.47296 7.22956L0.844363 5.29396C0.635563 5.13976 0.549163 4.86916 0.630163 4.62316C0.711763 4.37656 0.940963 4.21096 1.20016 4.21096H1.20136L4.43416 4.21816L5.42836 1.07896C5.50756 0.829356 5.73856 0.660156 6.00016 0.660156C6.26176 0.660156 6.49276 0.829356 6.57196 1.07896L7.56616 4.21816L10.799 4.21096H10.8002C11.0594 4.21096 11.2886 4.37656 11.3702 4.62316C11.4512 4.86916 11.3648 5.13976 11.156 5.29396L8.52736 7.22956L9.53776 10.3724C9.61756 10.6208 9.52816 10.892 9.31576 11.0438C9.21196 11.1188 9.08896 11.156 8.96656 11.156Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
